import { SVGProps } from 'react'

interface VerticalChevronProps extends SVGProps<SVGSVGElement> {
  strokeColor?: string
}

export const VerticalChevron = ({ strokeColor, ...props }: VerticalChevronProps) => {
  return (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Down Arrow 2">
        <path
          id="Vector 59"
          d="M13 1.5L7 7.5L1 1.5"
          stroke={strokeColor || 'black'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
